"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const patient_overview_table_1 = require("./patient-overview-table");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Styles = {
    patientOverviewTableRow: (rowType) => core_1.css `
        background-color: ${rowType === patient_overview_table_1.RowType.section ? styles_scss_1.default.backgroundGrey : styles_scss_1.default.white};
        font-weight: ${rowType === patient_overview_table_1.RowType.section ? '500' : '400'};
     `
};
exports.default = Styles;
